(function () {
  function initStickyVisibility(stickyBar) {
    if (stickyBar.__visibilityInitialized) return;
    stickyBar.__visibilityInitialized = true;

    var formId = stickyBar.getAttribute('form');
    if (!formId) return;

    // Busca el buy-buttons PRINCIPAL (el que está fuera del propio sticky bar)
    var primaryBuyButtons = null;
    document.querySelectorAll('buy-buttons[form="' + formId + '"]').forEach(function (el) {
      if (!el.closest('product-sticky-bar')) primaryBuyButtons = el;
    });
    if (!primaryBuyButtons) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { root: null, threshold: 0 });

    observer.observe(primaryBuyButtons);

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(stickyBar)) observer.disconnect();
    });
  }

  function init() {
    document.querySelectorAll('product-sticky-bar').forEach(initStickyVisibility);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('product-sticky-bar').forEach(initStickyVisibility);
  });
})();
